import { render, staticRenderFns } from "./PdfPreview.vue?vue&type=template&id=63c8beb7&"
import script from "./PdfPreview.vue?vue&type=script&lang=js&"
export * from "./PdfPreview.vue?vue&type=script&lang=js&"
import style0 from "./PdfPreview.vue?vue&type=style&index=0&id=63c8beb7&prod&lang=less&"
import style1 from "./PdfPreview.vue?vue&type=style&index=1&id=63c8beb7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports